import { isMobileOnly } from 'react-device-detect';
import { Map } from 'immutable';

import { getFromLocalStorage } from '../utils/localStorage';
import { isTrue } from '../utils/bool';

import { THEME_NAME } from './theme';
import { VELA_THEME } from './user';
import { FEATURE } from './features';
import { EMPTY } from '.';
import { PAGES } from './routes';

export const ADMIN = Map({
  shopCounts: EMPTY.MAP,
  shopsLookup: Map({
    query: '',
    result: EMPTY.LIST,
    loading: false,
  }),
  usersLookup: Map({
    query: '',
    result: EMPTY.LIST,
    loading: false,
  }),
  applicantsLookup: Map({
    result: EMPTY.LIST,
    loading: false,
    processing: EMPTY.LIST,
  }),
  payoutsLookup: Map({
    result: EMPTY.LIST,
    loading: false,
  }),
  shopDetails: Map({
    loading: false,
    refreshInProgress: false,
  }),
  userDetails: Map({
    loading: false,
  }),
  payoutsDetails: Map({
    loading: false,
  }),
  referralsLookup: Map({
    loading: false,
    result: EMPTY.LIST,
  }),
  referralsDetails: Map({
    loading: false,
  }),
  reassignShop: Map({
    user: EMPTY.MAP,
    query: '',
    result: EMPTY.LIST,
    loading: false,
  }),
  impersonation: EMPTY.MAP,
});

export const INITIAL_STATE = Map({
  admin: EMPTY.MAP,
  affiliate: EMPTY.MAP,
  auth: EMPTY.MAP,
  billing: EMPTY.MAP,
  bulkEdit: EMPTY.MAP,
  data: Map({
    isMobileOnly,
    sidebarHidden: Map(
      getFromLocalStorage({
        sidebarHidden: {
          [PAGES.ACCOUNT]: false,
          [PAGES.BULK_EDIT]: false,
          [PAGES.EDIT]: false,
          [PAGES.LISTINGS]: false,
          [PAGES.PROFILES]: false,
          [PAGES.SCHEDULE]: false,
          [PAGES.STUDIO]: false,
        },
      }).sidebarHidden
    ).filter(isTrue),
  }),
  edit: EMPTY.MAP,
  listings: EMPTY.MAP,
  notifications: EMPTY.LIST,
  profiles: EMPTY.MAP,
  schedule: EMPTY.MAP,
  shops: EMPTY.MAP,
  studio: Map({
    photos: EMPTY.MAP,
    uploading: EMPTY.MAP,
    videos: EMPTY.MAP,
  }),
  user: Map({
    features: Map({
      [FEATURE.REDESIGN]: true,
    }),
    ...getFromLocalStorage({
      [VELA_THEME]: THEME_NAME.LIGHT,
    }),
  }),
});
